import { render } from "./product-addons.vue?vue&type=template&id=f3c4c712&lang=pug"
import script from "./product-addons.vue?vue&type=script&lang=js"
export * from "./product-addons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__